export const changeformat = async (data: any) => {
 
  const newData = data.reduce((acc: any, currentItem: any) => {
    const { subsection, question } = currentItem
     //grouping each subsection deatils with section name
    if (subsection && subsection.section) {
      const { section } = subsection
      const { name } = section
      const existingGroup = acc.find((group: any) => group.name === name)
      if (existingGroup) {
        existingGroup.details = existingGroup.details.concat(question)
      } else {
        acc.push({
          name,
          details: question,
        })
      }
    }

    return acc
  }, [])
  
  //calculating the total mark of each section and total mark obtained in seach section
  const calculateSectionTotals = async (section: any) => {
    section.totalMarks = section.details.reduce((total: number, question: any) => total + (parseInt(question.candidateResult?.mark) || 0), 0)
    section.totalMarksObtained = section.details.reduce(
      (total: number, question: any) => total + (parseInt(question.candidateResult?.mark_scored) || 0),
      0
    )

    return section
  }
  
  // Use Promise.all to calculate totals for all sections in parallel
  const modifiedData = await Promise.all(newData.map(calculateSectionTotals))

  return modifiedData
}
